import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Mirror of the backend EmailValidator::REGEX (only \A...\z changed to ^...$).
 * Local part with letters/digits/_/+/-/& separated by single dots (no leading,
 * trailing or consecutive dots), domain labels that do not start or end with a
 * hyphen, and a TLD of at least 2 letters. This is what Brevo accepts, so any
 * email passing this regex no longer bounces on send.
 */
export const VALID_EMAIL_REGEX = /^[\w+\-&]+(?:\.[\w+\-&]+)*@(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z]{2,}$/i;

// Zero-width characters, BOM and soft hyphen; commonly pasted from mobile keyboards and rich editors.
const INVISIBLE_CHARS_REGEX = /[\u200B-\u200D\u2060\uFEFF\u00AD]/g;

/**
 * Mirror of the backend EmailNormalizable concern: strip invisible characters,
 * remove all whitespace (trim + inner spaces) and lowercase.
 */
export function normalizeEmail(value: string | null | undefined): string {
  if (!value) return "";
  return value.replace(INVISIBLE_CHARS_REGEX, "").replace(/\s+/g, "").toLowerCase();
}

/** True when the normalized value matches the backend email regex. */
export function isValidEmail(value: string | null | undefined): boolean {
  const normalized = normalizeEmail(value);
  return normalized.length > 0 && VALID_EMAIL_REGEX.test(normalized);
}

/**
 * Strict email format validator aligned with the backend (normalizes before
 * testing). Returns `{ email: true }` so templates checking `errors?.email`
 * keep working. Empty values are valid; combine with Validators.required.
 */
export const strictEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) return null;
  return isValidEmail(control.value) ? null : { email: true };
};
